let booted = false;
let _intercom;
let settings = {};

export default {
  configure: (opts = {}) => {
    settings = {
      ...settings,
      ...opts,
    };

    return settings;
  },

  boot: () => {
    if (!window.Intercom) {
      return false;
    }

    _intercom = window.Intercom;
    _intercom('boot', settings);
    booted = true;
  },

  shutdown: () => {
    if (!booted) {
      return false;
    }

    _intercom('shutdown');
  },

  trackEvent: (name, metadata = {}) => {
    if (!booted || !name) {
      return false;
    }

    _intercom('trackEvent', name, metadata);
  },
};
